import { Popover } from 'antd';
import { messageMenu } from '@/configs/router/menu';
import { useChatContext } from '@/contexts/chat/context';
import StatusBox from '../StatusBox';
import styles from './index.module.scss';
import TypeIcon from './images/type.svg?react';

const MessageHeader = () => {
  const { loading } = useChatContext();
  return (
    <div className={styles.messageHeader}>
      <div className={styles.test}>
        <Popover
          rootClassName={styles.msgTypePopoverWrapper}
          placement="bottomLeft"
          arrow={false}
          content={
            <div className={styles.popoverContent}>
              {messageMenu.map((item) => {
                return (
                  <Link
                    className={styles.msgNavItem}
                    key={item.key}
                    to={item.key as string}
                  >
                    <div>{item.icon}</div>
                    <div>{item.label}</div>
                  </Link>
                );
              })}
            </div>
          }
        >
          <div className={styles.msgTypeIcon}>
            <TypeIcon />
          </div>
        </Popover>
      </div>
      <div>
        <StatusBox loading={loading}>Messages</StatusBox>
      </div>
    </div>
  );
};
export default MessageHeader;
